module.exports = __webpack_public_path__ + "static/img/2a869043-ffec-4544-9aea-250a77ed71f5.f6303bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/2a869043-ffec-4544-9aea-250a77ed71f5.png
// module id = 7v8K
// module chunks = 1